import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { I18N, SessionProvider } from 'ess-plugin-base';
import { Constants } from '../Constants';
import { ResLinkAction } from './res.link.action';

@Component({
    selector: 'res-link',
    templateUrl: './res.link.html',
    styleUrls: ['./res.link.scss']  
})
export class ResLink implements OnInit, OnChanges {

    @Input('ns')
    namespace: string;

    @Input('res')
    res: string;

    @Input('data')
    data: any;

    @Input('prefetch')
    prefetch: boolean;

    // @Output("click")
    // onClick: 

    menu_items: ResLinkAction[] = [];

    // sub_lang: Subscription;

    loading: boolean;
    loaded: any;

    constructor(private http: HttpClient, private i18n: I18N,
            private session: SessionProvider) {}
    //         ,
    //         private platform: PlatformProvider) {
    // }

    ngOnInit() {
        if (this.data) {
            this.data = Object.assign({}, this.data);
        }
        if (this.prefetch) {
            this.loadItems();
        }
        // this.update();
        // this.sub_lang = this.i18n.observeLanguage().subscribe({
        //     next: (lang) => {
        //         this.localize();
        //     }
        // })
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data && this.data) {
            this.data = Object.assign({}, this.data);
            // this.update();
        }
        if (changes.prefetch && (changes.res || changes.prefetch || changes.data)) {
            this.loadItems();
        }
    }

    ngOnDestroy() {
        // if (this.sub_lang) this.sub_lang.unsubscribe();
    }
    
    loadItems() {
        if (!this.loaded && !this.loading) {
            this.menu_items = [];
            this.loading = true;

            let url = Constants.protocol + Constants.nameServer + '/instance';
            url += '?ns=' + this.namespace;
            url += '&res=' + this.res;

            this.http.get(url, Constants.httpOptions)
            .toPromise()
            .then((json: any) => {
                this.loaded = json;
                this.loading = null;

                if (json && json.actions && Array.isArray(json.actions)) {
                    Object.assign(this.data, json);

                    json.actions.map(action => {
                        let item = new ResLinkAction(this.session); //platform);
                        item.name = action.name;
                        item.caption = action.caption;
                        item.i18n = action.i18n;
                        item.icon = action.icon;
                        item.route = action.command;
                        item.plugin = action.module;

                        this.menu_items.push(item);
                    })
                }
            })
        }
    }

    localize() {
        // if (this.namespace) {
        //     this.loaded = null;
        //     this.menu_items = [];
        //     this.loadItems();
        //     // this.menu_items = PlatformProvider.contextMenus.get(this.namespace) || [];
        // }
    }

    run(item: ResLinkAction) {
        item.run(this.data);
    }

}